import { combineReducers } from 'redux';
import { createSimpleToggleReducer } from '../../redux-util/general-helpers';
import * as act from './kiddie-actions';
import { withDestroyViewerReset } from '../../reset-reducer-helpers';

export default combineReducers({
  isReadAloudOpen: withDestroyViewerReset(
    createSimpleToggleReducer(act.toggleReadAloud().type, false)
  ),
  isBookCompleteShowing: withDestroyViewerReset(
    createSimpleToggleReducer(act.toggleBookCompletePage().type, false)
  ),
  areToolsCollapsed: createSimpleToggleReducer(
    act.toggleToolsCollapsed().type,
    false
  ),
});
